export default __webpack_public_path__ + "static/media/insurance-first-layer-bottom.9137b4e4.svg";